import {IDirective} from "angular";
import {SystemAlertStore} from "../../alerts/store/SystemAlertStore";
import {SystemPromptStore} from "../../prompts/store/SystemPromptStore";
import {isNotNull} from "../../../../js/util/UtilFunctions";
import {Observable} from "rxjs";

export const SystemMessage = "tfSystemMessage";

/** @ngInject */
export function systemMessage(systemAlertStore: SystemAlertStore, systemPromptStore: SystemPromptStore): IDirective {
    return {
        restrict: "A",
        link: (scope, elem, attr) => {
            const hasAlert = systemAlertStore.current
                                             .map(isNotNull)
                                             .startWith(false);
            const hasPrompt = systemPromptStore.current
                                               .map(isNotNull)
                                               .startWith(false);
            const source = Observable.combineLatest(hasAlert, hasPrompt);

            source.subscribe(([alert, prompt]) => {
                if (alert || prompt) {
                    elem.addClass("has-system-message");
                } else {
                    elem.removeClass("has-system-message");
                }
            });
        }
    };
}
